/**
 * PDP: hide the first icon-with-text row (IGI trust) when selected carat is strictly under 1 ct.
 * Relies on `data-bm-pdp-igi-trust-item` + `data-bm-carat-option-position` from `icon-with-text.liquid`.
 */
(function () {
  /**
   * @param {{ option1?: string, option2?: string, option3?: string } | null | undefined} variant
   * @param {number} pos 1–3
   * @returns {number | null} carat in ct, or null if not parseable
   */
  function bmParseCaratCt(variant, pos) {
    if (!variant || pos < 1 || pos > 3) return null;
    const raw = pos === 1 ? variant.option1 : pos === 2 ? variant.option2 : variant.option3;
    if (raw == null || raw === '') return null;
    const m = String(raw)
      .replace(/,/g, '.')
      .match(/[\d.]+/);
    if (!m) return null;
    const n = parseFloat(m[0], 10);
    return Number.isFinite(n) ? n : null;
  }

  /**
   * @param {Element} productInfo
   */
  function bmApplyIgiTrustVisibility(productInfo) {
    const item = productInfo.querySelector('[data-bm-pdp-igi-trust-item]');
    if (!item) return;

    const pos = parseInt(item.getAttribute('data-bm-carat-option-position') || '', 10);
    if (!Number.isFinite(pos) || pos < 1 || pos > 3) {
      item.classList.remove('hidden');
      return;
    }

    const getSel =
      typeof productInfo.getSelectedVariant === 'function'
        ? productInfo.getSelectedVariant.bind(productInfo)
        : null;
    if (!getSel) return;

    const variant = getSel(productInfo);
    const ct = bmParseCaratCt(variant, pos);

    if (ct == null || ct <= 0) {
      item.classList.remove('hidden');
      return;
    }

    item.classList.toggle('hidden', ct < 1);
  }

  function bmApplyAll() {
    document.querySelectorAll('product-info').forEach(bmApplyIgiTrustVisibility);
  }

  document.addEventListener('variant:changed', function () {
    requestAnimationFrame(bmApplyAll);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bmApplyAll);
  } else {
    bmApplyAll();
  }
})();
